import { Backdrop, CircularProgress } from "@mui/material";

const CustomBackdrop = ({
    open
}) =>{

    return (
        <Backdrop
          sx={(theme) => ({ 
            color: '#fff',
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.7)", // 🔥 más oscuro (0.9 casi negro)
        })}
          open={open}>
              <CircularProgress color="inherit"/>
        </Backdrop>
    );
}

export default CustomBackdrop;